<div class="login-wrapper">
  <div *ngIf="sessionExpiredMessage" class="alert alert-warning">
    {{ sessionExpiredMessage }}
  </div>
  <div class="brand-logo">
    <img src="../assets/images/klusup.png" alt="KLUSUP Dashboard" width="300">
  </div>
  <div class="container" id="container">
    <div class="form-container sign-in-container">
      <form [formGroup]="loginForm">
        <h1 class="login-text">Login</h1>
        <input type="email" formControlName="userName" placeholder="User Name" />
        <button (click)="loginHere()" *ngIf="!showPasscode">Get Verification Code</button>

        <input type="email" formControlName="passcode" placeholder="Enter passcode sent to your mail"
          *ngIf="showPasscode" />
        <div *ngIf="showPasscode" class="resend-container">
          <p>{{timeLeft}} Seconds Left....</p>
          <button *ngIf="timeLeft <= 10" class="resend-btn" (click)="loginHere()" aria-label="Resend">Resend</button>
        </div>
        <button (click)="validateLoginToken()" *ngIf="showPasscode">Submit</button>
      </form>
    </div>

    <div class="overlay-container">
      <div class="overlay">
        <div class="overlay-panel overlay-left">
          <h1>Hello, Friend!</h1>
          <p>To keep connected with us please login with your personal info</p>
        </div>
        <div class="overlay-panel overlay-right">
          <h1 >Welcome </h1>
        </div>
      </div>
    </div>
  </div>
</div>